<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>财务管理</el-breadcrumb-item>
            <el-breadcrumb-item>生成对账单</el-breadcrumb-item>
        </el-breadcrumb>

        <el-form :inline="true" :model="item" class="search">
            <el-form-item label="订单号">
                <el-input v-model="item.phone" placeholder="请输入订单号"
                          size="small"></el-input>
            </el-form-item>
            <el-form-item label="所属供应商">
                <el-select v-model="item.shop" placeholder="所属供应商" size="small">
                    <el-option label="蒙牛集团" value=""></el-option>
                    <el-option label="gongys" value=""></el-option>
                    <el-option label="厦门点微信息" value=""></el-option>
                    <el-option label="软件园独家代理" value=""></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="时间">
                <el-date-picker
                        size="small"
                        style="margin-left: 10px"
                        v-model="value2"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit" size="medium">查询</el-button>
                <el-button type="primary" @click="submit" size="medium">生成对账单</el-button>
            </el-form-item>
        </el-form>
        <div class="btns">
            <el-button type="danger" size="small" @click="delAll">批量删除</el-button>
        </div>
        <!--		数据是list 通过list展示-->
        <el-table :data="list" border>
            <el-table-column type="selection" align="center"></el-table-column>
			<el-table-column width="60" align="center">
				<template slot-scope="scope">
					{{scope.$index + (page-1) * pageSize + 1}}
				</template>
			</el-table-column>

            <el-table-column prop="indent" label="订单号"></el-table-column>
            <el-table-column prop="name" label="商品名称"></el-table-column>
            <el-table-column prop="num" label="数量"></el-table-column>
            <el-table-column prop="fee" label="金额"></el-table-column>
            <el-table-column prop="supplier" label="所属供应商"></el-table-column>
            <el-table-column prop="date" label="创建日期"></el-table-column>

        </el-table>
        <el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page"
                       :page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
</template>
<script>
    export default {
        name: 'index',
        data() {
            return {
                list: [{
                    id: 1,
                    number: '1',
                    indent: '1',
                    name: '商品名称1',
                    num: 1000,
                    fee: "100.00",
                    supplier: '蒙牛集团',
                    date: "2021-07-01 17:24:28"
                }, {
                    id: 2,
                    number: '2',
                    indent: '2',
                    name: '商品名称2',
                    num: 1000,
                    fee: "10110.00",
                    supplier: 'gongys',
                    date: "2021-07-01 17:24:28"
                }, {
                    id: 3,
                    number: '3',
                    indent: '3',
                    name: '商品名称3',
                    num: 101100,
                    fee: "10004110.00",
                    supplier: '厦门点微信息',
                    date: "2021-07-01 17:24:28"
                }],
                isLoad: false,
                pageSize: 20,
                total: 0,
                page: 1,
                // 查询
                item: {},
                value2: ''
            }
        },
        created() {
            // this.loadList()
        },
        methods: {
            loadList() {
                if (this.isLoad)
                    return
                this.isLoad = !this.isLoad
                this.axios.post('/admin/business/store/list', {
                    page: this.page,
                    limit: this.pageSize
                })
                    .then(res => {
                        this.isLoad = !this.isLoad
                        // 获取数据
                        this.list = res.data.records
                        // 页数 page
                        this.total = res.data.total
                    })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            },
            // 跳转到edit添加
            add() {
                return
                this.$router.push({path: '/Member/MemberLevelEdit.html'});
            },
            audit(id) {
                this.$router.push({
                    path: '/Finance/audioStatement.html',
                    query: {
                        id: id
                    }
                });
            },
            // 传一个ID跳转到edit页面，进行编辑
            end(id) {
                this.$router.push({
                    path: '/Finance/endStatement.html',
                    query: {
                        id: id
                    }
                });
            },
            //
            del(id) {
                if (this.isLoad) {
                    return
                }
                this.isLoad = !this.isLoad
                this.axios.delete('/admin/business/store/delete', {
                    data: [
                        id
                    ]
                })
                    .then(() => {
                        this.isLoad = !this.isLoad
                        this.$message.success({
                            message: '删除成功',
                            showClose: false
                        });
                        this.loadList()
                    })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            delAll() {
                let id = []
                for (let key in this.multipleSelection) {
                    let item = this.multipleSelection[key]
                    id.push(item.id)
                }
                if (this.isLoad)
                    return
                this.isLoad = !this.isLoad
                this.axios.delete('/admin/business/storeRank/delete', {
                    data: id
                }).then(() => {
                    this.isLoad = !this.isLoad
                    this.$message.success({
                        message: '删除成功',
                        showClose: false
                    });
                    this.loadList()
                })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            },
            sizeReload(val) {
                this.pageSize = val
                this.loadList()
            },
            pageReload(val) {
                this.page = val
                this.loadList()
            },
            // 搜索查询
            submit() {
                this.item.page = 1
                this.loadList()
            },
            // 导出
            excelOut() {
                return;
                if (this.isLoad)
                    return
                this.isLoad = !this.isLoad
                this.axios.get('/Member/excelOut', {
                    params: {
                        nickname: this.item.nickname,
                        title: this.item.title
                    }
                })
                    .then(res => {
                        this.isLoad = !this.isLoad
                        // 导出
                        window.open(res.url)
                    })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            }
        },

    }
</script>
<style scoped>

</style>